const ErrorPage = () => {
  return <div>The page has not been found.</div>;
};

export default ErrorPage;
